import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FDPaper } from '@facet-wealth/design';

const useStyles = makeStyles(() => ({
  root: {
    fontFamily: 'Euclid Square, sans-serif',
  },
}));
const Main = (props) => {
  const { children } = props;

  const classes = useStyles();
  return (
    <div className={`blueprint-main ${classes.root}`}>
      <FDPaper overflow="hidden">{children}</FDPaper>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Main;
